import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import * as moment from 'moment';
import { isEnrolledOrFree } from '../../../services/utilityFunctions';
import LoggedUserContext from '../../../contextProviders/LoggedUserContext';
import Anchor from '../../../commonComponents/Anchor';
import translate from '../../../commonComponents/translate';
import CourseProp from '../propTypes/courseProp';
import AcademyFooterContainer from '../../../commonComponents/container/AcademyFooterContainer';
import CertificateIcon from '../../../commonComponents/icons/CertificateIcon';
import PriceDisplay from '../../../commonComponents/PriceDisplay';

const detailsLinkText = (loggedUser, course) => {
  if (isEnrolledOrFree(loggedUser, course) && course.progress === 0) {
    return 'start';
  }
  if (course.progress > 0 && course.progress < 100) {
    return 'continue';
  }
  return 'details';
};

function RelatedCourseItem({ t, course, className }) {
  const { loggedUser } = useContext(LoggedUserContext);

  const duration = moment.duration(course.duration);
  const hours =
    duration.days() > 0
      ? duration.days() * 24 + duration.hours()
      : duration.hours();
  const durationCompose = ` ${hours}h:${duration.minutes()}m`;

  const image = course.imageSquare || course.image;
  const imageURL = image ? image.thumb : '/image/no_image_upload.png';

  const containerClass = cx(
    'm-portlet',
    'm-portlet--rounded',
    'm-portlet--rounded-force',
    'academy-course-item',
    'academy-related-course',
    className,
  );

  return (
    <div className={containerClass}>
      <div className="m-portlet__body course-container-body">
        <div className="related-details">
          <Anchor
            itemProp="url"
            content={`/academy/${course.slug}`}
            href={`/academy/${course.slug}/play`}
            className="course-image course-play-button wide-play-button"
          >
            <img
              itemProp="image"
              content={imageURL}
              src={imageURL}
              alt="course"
            />
          </Anchor>
          <div className="course-details">
            <div className="course-header">
              <span className="course-header-name">{course.name}</span>
            </div>
            <div className="course-description-and-progress">
              <div className="course-description">{course.summary}</div>
            </div>
            <div className="course-subheader">
              {duration > 0 && (
                <AcademyFooterContainer
                  faIcon="la la-clock-o"
                  text={durationCompose}
                />
              )}
              {course.certificate && course.certificate.isActive && (
                <AcademyFooterContainer
                  customIcon={<CertificateIcon />}
                  text={t('reward.certificate')}
                />
              )}
              <div className="price-display-related-container">
                <PriceDisplay
                  type="course"
                  t={t}
                  userPrice={course?.userPrice}
                  userPromotionPrice={course?.userPromotionPrice}
                  withWrapper
                />
              </div>
            </div>
          </div>
          <div className="course-actions">
            <Anchor
              href={`/academy/${course.slug}`}
              className="btn m-btn--pill btn-dynamic navigation-button"
            >
              {t(detailsLinkText(loggedUser, course))}
            </Anchor>
          </div>
        </div>
      </div>
    </div>
  );
}

RelatedCourseItem.propTypes = {
  t: PropTypes.func.isRequired,
  className: PropTypes.string,
  course: PropTypes.shape(CourseProp.propType).isRequired,
};

RelatedCourseItem.defaultProps = {
  className: '',
};

export default translate(RelatedCourseItem);
